import { render, staticRenderFns } from "./formRole.vue?vue&type=template&id=0df3752e&scoped=true&"
import script from "./formRole.vue?vue&type=script&lang=js&"
export * from "./formRole.vue?vue&type=script&lang=js&"
import style0 from "./formRole.vue?vue&type=style&index=0&id=0df3752e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3752e",
  null
  
)

export default component.exports